// Layout shell del pannello configurazione (Sprint 5).
// Sub-nav verticale + Outlet per le sotto-pagine.

import { NavLink, Outlet } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

interface NavItem {
  label: string;
  to: string;
  end?: boolean;
  masterOnly?: boolean;
}

const NAV_ITEMS: NavItem[] = [
  { label: 'Identità installazione', to: '/settings/identity', masterOnly: true },
  { label: 'Brand', to: '/settings/brand', masterOnly: true },
  { label: 'Comportamento LLM', to: '/settings/llm', masterOnly: true },
  { label: 'Modalità voce', to: '/settings/voice', masterOnly: true },
  { label: 'Limiti consumo', to: '/settings/limits', masterOnly: true },
  { label: 'Retention', to: '/settings/retention', masterOnly: true },
  { label: 'Email & alert', to: '/settings/email', masterOnly: true },
  { label: 'Privacy', to: '/settings/privacy', masterOnly: true },
  { label: 'Utenti admin', to: '/settings/users', masterOnly: true },
  { label: 'Audit log', to: '/settings/audit', masterOnly: true },
  { label: 'Sicurezza personale', to: '/settings/security' },
];

export function SettingsLayout() {
  const meQuery = useQuery({ queryKey: ['me'], queryFn: () => api.me() });
  const role = meQuery.data?.user.role;
  const isMaster = role === 'master';

  return (
    <div className="mx-auto max-w-6xl">
      <h1 className="serif mb-2 text-3xl" style={{ color: 'var(--ink)' }}>
        Configurazione
      </h1>
      <p className="mb-6 mono text-sm" style={{ color: 'var(--mute)' }}>
        Pannello self-service · {isMaster ? 'Tutte le sezioni' : 'Solo sicurezza personale'}
      </p>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-[220px_1fr]">
        <aside
          className="rounded-md border p-3"
          style={{ background: 'var(--paper)', borderColor: 'var(--line)' }}
        >
          <nav>
            <ul className="space-y-0.5">
              {NAV_ITEMS.filter((it) => !it.masterOnly || isMaster).map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    end={item.end}
                    className="block rounded-md px-3 py-2 text-sm transition"
                    style={({ isActive }) => ({
                      background: isActive ? 'var(--soft)' : 'transparent',
                      color: isActive ? 'var(--primary-2)' : 'var(--ink)',
                      fontWeight: isActive ? 600 : 400,
                    })}
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </aside>

        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
